var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasuringTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43655 23L10.6187 7.04733M20.2179 23L13.0358 7.04733M3.02222 13.9532C5.71552 16.5084 13.0772 20.0857 20.9776 13.9532",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8516 1.79982C13.3393 1.79995 14.5449 3.00643 14.5449 4.49416C14.5448 5.53796 13.9518 6.44489 13.0801 6.89259C12.7127 7.08128 12.2956 7.18748 11.8516 7.18752C10.3638 7.18752 9.15736 5.98185 9.15723 4.49416C9.15723 3.00636 10.3638 1.79982 11.8516 1.79982Z",
    stroke: "black",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasuringTool);
export default __webpack_public_path__ + "static/media/measuring-tool.7f984c22dc34b805af7a80c3347f7f68.svg";
export { ForwardRef as ReactComponent };